import { observable, action, makeObservable } from 'mobx'

import { APP_CONFIG_GET_A_NEWS_LETTER_ORIGIN } from '@config/app.config'

class ErrorDialogModel {
  @observable error = {
    show: false,
    message: '',
    status: '',
    retry: null,
  }

  // How many times the dialog was raised. "Try to reconnect" compares it before
  // and after its retry: a retry that fails the same way raises the dialog
  // again, while one that saves or gets a 4xx (shown in the save error
  // banner) does not. See FE-1431.
  shownCount = 0

  @action showError = (error) => {
    this.shownCount += 1
    this.error.show = true
    this.error.message = error.message
    this.error.status = error.status
    this.error.retry = error.retry
    if (error.status === 401) {
      window.location = `${APP_CONFIG_GET_A_NEWS_LETTER_ORIGIN}/mails/`
    }
  }

  @action hideError = () => {
    this.error.show = false
    this.error.message = ''
    this.error.status = ''
    this.error.retry = null
  }

  constructor() {
    makeObservable(this)
  }
}

export const errorDialogModel = new ErrorDialogModel()
export const showError = errorDialogModel.showError
export const hideError = errorDialogModel.hideError
